import { render, staticRenderFns } from "./user-image.vue?vue&type=template&id=6f9f77ca&scoped=true&lang=pug"
import script from "./user-image.vue?vue&type=script&lang=js"
export * from "./user-image.vue?vue&type=script&lang=js"
import style0 from "./user-image.vue?vue&type=style&index=0&id=6f9f77ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f77ca",
  null
  
)

export default component.exports